import { propertyMeta, typeMeta, MetaTypesBase } from "@/autogen/common";

export const CreatePersonMemberMetaFields = {
  email: propertyMeta("email", false, false, false, MetaTypesBase.string),
  dob: propertyMeta("dob", false, false, false, MetaTypesBase.LocalDate),
  gender: propertyMeta("gender", false, false, false, MetaTypesBase.string),
  ethnicity: propertyMeta("ethnicity", false, false, false, MetaTypesBase.string),
  language: propertyMeta("language", false, false, false, MetaTypesBase.string),
  school: propertyMeta("school", false, false, false, MetaTypesBase.string),
  swimProof: propertyMeta("swimProof", false, false, false, MetaTypesBase.number),
  sailingExp: propertyMeta("sailingExp", false, false, false, MetaTypesBase.string),
  allergies: propertyMeta("allergies", false, false, false, MetaTypesBase.string),
  medications: propertyMeta("medications", false, false, false, MetaTypesBase.string),
  specialNeeds: propertyMeta("specialNeeds", false, false, false, MetaTypesBase.string),
  employer: propertyMeta("employer", false, false, false, MetaTypesBase.string),
  occupation: propertyMeta("occupation", false, false, false, MetaTypesBase.string),
  matchingGifts: propertyMeta("matchingGifts", false, false, false, MetaTypesBase.string),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta("createdBy", false, false, false, MetaTypesBase.string),
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta("updatedBy", false, false, false, MetaTypesBase.string),
  prefix: propertyMeta("prefix", false, false, false, MetaTypesBase.string),
  first: propertyMeta("first", false, false, false, MetaTypesBase.string),
  middle: propertyMeta("middle", false, false, false, MetaTypesBase.string),
  last: propertyMeta("last", false, false, false, MetaTypesBase.string),
  suffix: propertyMeta("suffix", false, false, false, MetaTypesBase.string),
  preferred: propertyMeta("preferred", false, false, false, MetaTypesBase.string),
};

export const CreatePersonMemberMeta = typeMeta("CreatePersonMember", CreatePersonMemberMetaFields);
